<template>
	<a-modal
		:visible="visible"
		:mask-closable="false"
		title="添加日常"
		width="700px"
		@ok="handleOk"
		@cancel="handleCancel"
	>
		<a-form-model
			ref="momentAddAdminForm"
			:model="momentAddForm"
			:label-col="{ span: 4 }"
			:wrapper-col="{ span: 14 }"
		>
			<a-form-model-item label="发布类型">
				<a-select v-model="selectType" style="width: 120px" @change="onTypeChanged">
					<a-select-option value="photo">图片</a-select-option>
					<a-select-option value="video">视频</a-select-option>
				</a-select>
			</a-form-model-item>

			<a-form-model-item
				v-if="selectType == 'photo'"
				label="图片集"
				prop="materialUrl"
				:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]"
			>
				<x-images ref="xImages" @change="onMomentImagesChange" />
			</a-form-model-item>

			<template v-if="selectType == 'video'">
				<a-form-model-item
					label="封面图"
					prop="coverUrl"
					:rules="[{ required: true, message: '请上传视频封面', trigger: 'change' }]"
				>
					<x-image
						v-if="momentAddForm.coverUrl"
						:src="momentAddForm.coverUrl"
						:preview-src="momentAddForm.coverUrl + '?x-oss-process=image/resize,w_64,h_64,m_fill'"
					/>
					<a-input v-show="false" v-model="momentAddForm.coverUrl" />
					<a-upload
						list-type="picture"
						:multiple="false"
						:show-upload-list="false"
						accept="image/jpeg,image/png,image/gif,image/webp"
						:before-upload="beforeCoverUpload"
						:custom-request="coverUpload"
					>
						<a-button><a-icon type="upload" />上传封面</a-button>
					</a-upload>
				</a-form-model-item>
				<a-form-model-item
					label="视频"
					prop="materialUrl"
					:rules="[{ required: true, message: '请上传视频', trigger: 'change' }]"
				>
					<x-videos
						ref="xVideos"
						:cover-url="momentAddForm.coverUrl"
						@change="onMomentVideosChange"
					/>
					<a-input v-show="false" v-model="momentAddForm.materialUrl" />
					<div v-if="vodPlayFetching" class="vod-play-hint">
						<a-icon type="loading" /> 正在获取视频转码信息…
					</div>
					<div v-else-if="momentAddForm.materialUrl && vodTranscodeReady" class="vod-play-hint vod-play-hint--ok">
						<a-icon type="check-circle" theme="filled" /> 转码信息已获取
					</div>
					<div v-else-if="momentAddForm.materialUrl && !vodTranscodeReady" class="vod-play-hint vod-play-hint--warn">
						转码信息获取失败，请重新上传视频
					</div>
				</a-form-model-item>
				
			</template>

			<a-form-model-item label="内容" prop="content">
				<a-textarea v-model="momentAddForm.content" :auto-size="{ minRows: 3, maxRows: 8 }" />
			</a-form-model-item>
			<a-form-model-item
				label="点赞量"
				prop="likeNum"
				:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]"
			>
				<a-input-number v-model="momentAddForm.likeNum" :min="0" />
			</a-form-model-item>
			<a-form-model-item
				label="转发量"
				prop="relayNum"
				:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]"
			>
				<a-input-number v-model="momentAddForm.relayNum" :min="0" />
			</a-form-model-item>
		</a-form-model>
	</a-modal>
</template>

<script>
	import XImages from '@/components/XImages';
	import XVideos from '@/components/XVideos';
	import XImage from '@/components/XImage';
	import { uploadImage } from '@/api/app.js';
	import { vodPlayList } from '@/utils/requestJava.js';

	function emptyMomentForm() {
		return {
			materialUrl: '',
			coverUrl: '',
			videoDuration: 0,
			content: '',
			likeNum: undefined,
			relayNum: undefined,
		};
	}

	export default {
		name: 'MomentForm',
		components: {
			XImages,
			XVideos,
			XImage,
		},
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			userId: {
				type: Number,
				default: 0,
			},
		},
		data() {
			return {
				selectType: 'photo',
				momentAddForm: emptyMomentForm(),
				vodPlayFetching: false,
				vodTranscodeReady: false,
				vodPlayListData: null,
			};
		},
		watch: {
			visible(val) {
				if (val) {
					this.resetInner();
				}
			},
		},
		methods: {
			resetVodPlayState() {
				this.vodPlayFetching = false;
				this.vodTranscodeReady = false;
				this.vodPlayListData = null;
			},
			isValidPlayList(playList) {
				return playList && typeof playList === 'object' && Object.keys(playList).length > 0;
			},
			/** 上传完成后请求转码播放列表（一次） */
			async fetchVodPlayList(videoUrl) {
				if (!videoUrl) {
					this.resetVodPlayState();
					return false;
				}
				this.vodPlayFetching = true;
				this.vodTranscodeReady = false;
				this.vodPlayListData = null;
				try {
					const res = await vodPlayList(videoUrl);
					console.log('vodPlayListRes', res);
					const playList = res.data && res.data.playList;
					if (res.isSucceed && this.isValidPlayList(playList)) {
						this.vodPlayListData = playList;
						this.vodTranscodeReady = true;
						return true;
					}
					this.$message.warning(res.message || '视频转码信息获取失败');
					return false;
				} catch (e) {
					this.$message.error('获取视频转码信息失败');
					return false;
				} finally {
					this.vodPlayFetching = false;
				}
			},
			resetInner() {
				this.selectType = 'photo';
				this.momentAddForm = emptyMomentForm();
				this.resetVodPlayState();
				this.$nextTick(() => {
					if (this.$refs.xImages && this.$refs.xImages.clearFiles) {
						this.$refs.xImages.clearFiles();
					}
					if (this.$refs.xVideos && this.$refs.xVideos.clearFiles) {
						this.$refs.xVideos.clearFiles();
					}
					if (this.$refs.momentAddAdminForm) {
						this.$refs.momentAddAdminForm.clearValidate();
					}
				});
			},
			onTypeChanged() {
				this.momentAddForm.materialUrl = '';
				this.momentAddForm.coverUrl = '';
				this.momentAddForm.videoDuration = 0;
				this.resetVodPlayState();
				this.$nextTick(() => {
					if (this.$refs.momentAddAdminForm) {
						this.$refs.momentAddAdminForm.clearValidate(['materialUrl', 'coverUrl']);
					}
				});
			},
			onMomentImagesChange(urls) {
				this.momentAddForm.materialUrl = urls || '';
			},
			async onMomentVideosChange(payload) {
				if (typeof payload === 'string') {
					this.momentAddForm.materialUrl = payload || '';
					this.momentAddForm.videoDuration = 0;
				} else if (payload && typeof payload === 'object') {
					this.momentAddForm.materialUrl = payload.url || '';
					const d = payload.duration;
					this.momentAddForm.videoDuration =
						typeof d === 'number' && Number.isFinite(d) ? d : 0;
					if (payload.coverUrl) {
						this.momentAddForm.coverUrl = payload.coverUrl;
					}
				} else {
					this.momentAddForm.materialUrl = '';
					this.momentAddForm.videoDuration = 0;
				}

				const videoUrl = this.momentAddForm.materialUrl;
				if (!videoUrl) {
					this.resetVodPlayState();
				} else {
					await this.fetchVodPlayList(videoUrl);
				}

				this.$nextTick(() => {
					if (this.$refs.momentAddAdminForm) {
						this.$refs.momentAddAdminForm.validateField('materialUrl');
					}
				});
			},
			beforeCoverUpload(file) {
				const isImage = file.type.startsWith('image/');
				if (!isImage) {
					this.$message.error('只能上传图片文件');
					return false;
				}
				const maxSizeMb = 5;
				if (file.size / 1024 / 1024 >= maxSizeMb) {
					this.$message.error(`封面图大小不能超过 ${maxSizeMb}MB`);
					return false;
				}
				return true;
			},
			coverUpload(req) {
				const f = req.file;
				const blob = f && (f.originFileObj || f.file || f);
				if (!blob || !blob.type.startsWith('image/')) {
					this.$message.error('只能上传图片文件');
					return;
				}
				const formData = new FormData();
				formData.append('xupload', blob);
				formData.append('type', 'moment');
				uploadImage(formData).then((res) => {
					if (res.isSucceed) {
						this.momentAddForm.coverUrl = res.data.url;
						this.$nextTick(() => {
							if (this.$refs.momentAddAdminForm) {
								this.$refs.momentAddAdminForm.validateField('coverUrl');
							}
						});
					} else {
						this.$message.error(`上传封面错误：${(res.data && res.data.message) || res.message || '未知错误'}`);
					}
				});
			},
			handleOk() {
				if (!this.$refs.momentAddAdminForm) {
					return;
				}
				if (this.userId <= 0) {
					this.$message.error('用户无效');
					return;
				}
				this.$refs.momentAddAdminForm.validate((valid) => {
					if (!valid) {
						return;
					}
					if (this.selectType === 'video') {
						if (!this.vodTranscodeReady || !this.isValidPlayList(this.vodPlayListData)) {
							this.$message.error('视频转码信息未获取成功，无法提交');
							return;
						}
					}
					const payload = {
						...this.momentAddForm,
						userId: this.userId,
						type: this.selectType,
					};
					if (this.selectType === 'video') {
						payload.materialUrl = JSON.stringify({
							videoUrl: this.momentAddForm.materialUrl || '',
							coverUrl: this.momentAddForm.coverUrl || '',
							duration: this.momentAddForm.videoDuration || 0,
							playList: this.vodPlayListData,
						});
						delete payload.coverUrl;
						delete payload.videoDuration;
					}
					this.$emit('ok', payload);
				});
			},
			handleCancel() {
				this.$emit('cancel');
			},
			/** 提交成功或父级关闭弹窗后调用，清空上传状态 */
			clearAfterSubmit() {
				if (this.selectType === 'photo') {
					if (this.$refs.xImages && this.$refs.xImages.clearFiles) {
						this.$refs.xImages.clearFiles();
					}
				} else if (this.$refs.xVideos && this.$refs.xVideos.clearFiles) {
					this.$refs.xVideos.clearFiles();
				}
				this.momentAddForm = emptyMomentForm();
				this.resetVodPlayState();
				this.$nextTick(() => {
					if (this.$refs.momentAddAdminForm) {
						this.$refs.momentAddAdminForm.clearValidate();
					}
				});
			},
			clearAndClose() {
				if (this.selectType === 'photo') {
					if (this.$refs.xImages && this.$refs.xImages.clearFiles) {
						this.$refs.xImages.clearFiles();
					}
				} else if (this.$refs.xVideos && this.$refs.xVideos.clearFiles) {
					this.$refs.xVideos.clearFiles();
				}
				this.momentAddForm = emptyMomentForm();
				this.resetVodPlayState();
				this.$nextTick(() => {
					if (this.$refs.momentAddAdminForm) {
						this.$refs.momentAddAdminForm.clearValidate();
					}
				});
			},
		},
	};
</script>

<style scoped>
	.vod-play-hint {
		margin-top: 8px;
		font-size: 12px;
		color: rgba(0, 0, 0, 0.45);
	}
	.vod-play-hint--ok {
		color: #52c41a;
	}
	.vod-play-hint--warn {
		color: #faad14;
	}
</style>
